// consistent animation durations
export const durations = {
  short: 250,
  basic: 400,
  basicPlus: 600,
  medium: 800,
} as const

export type TDuration = keyof typeof durations

export const getDurationValueMs = (durationKey: TDuration) => {
  return durations[durationKey]
}

export const breakpoints = {
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1800,
}

// ! probably does not work on the server
export const getPxInRem = () => {
  if (typeof getComputedStyle === 'undefined') {
    return 16
  }

  return parseFloat(getComputedStyle(document.documentElement).fontSize) ?? 16
}

export const aspectRatios = {
  square: 1,
  rectangle: 2.3,
  threeToTwo: 3 / 2,
  threeToOne: 3,
}

export type TAspectRatio = keyof typeof aspectRatios

export const clipPaths = {
  bottomEllipse: `ellipse(140% 100% at 50% 0)`,
}
